"use client";

import { MATCH_STATUS as STATUS } from "contants";
import { formatDateTime } from "@/utils/format";
import ICON_CALENDAR from "@/assets/images/cumeo-calendar.svg";
import ICON_CLOCK from "@/assets/images/cumeo-clock.svg";

export default function CumeoMatchMinute({
  liveScore,
  status,
  matchTime,
  halfStartTime,
  isLive,
  isMobile = false,
  className = "",
}) {
  const isCheckingVar = !!liveScore?.var;
  let matchStatus = "--";
  let currentMinute = null;
  let showMatchTime = false;

  const currentStatus = liveScore?.status !== undefined
    ? Number(liveScore.status)
    : status;

  if (isCheckingVar) {
    matchStatus = "VAR";
  } else if (
    liveScore?.minute !== undefined ||
    liveScore?.currentMinute !== undefined
  ) {
    currentMinute = liveScore?.minute ?? liveScore?.currentMinute;
    showMatchTime = true;
  } else {
    const timeStart = liveScore?.halfStartTime || (currentStatus === STATUS.FIRST_HALF ? matchTime : halfStartTime);
    const currentTime = Math.floor(Date.now() / 1000);

    if (timeStart != null && timeStart !== "") {
      const startTimeUnix =
        !isNaN(Number(timeStart))
          ? Number(timeStart)
          : Math.floor(new Date(timeStart).getTime() / 1000);

      switch (currentStatus) {
        case STATUS.FIRST_HALF:
          showMatchTime = true;
          currentMinute = Math.floor((currentTime - startTimeUnix) / 60);
          if (currentMinute >= 45) {
            currentMinute = `45+${currentMinute - 45}`;
          }
          break;

        case STATUS.SECOND_HALF:
          showMatchTime = true;
          if (!Number.isFinite(Number(timeStart)) || Number(timeStart) <= 0) {
            currentMinute = 45;
            break;
          }
          const secondHalfMinute = 45 + Math.floor((currentTime - Number(timeStart)) / 60);
          if (!Number.isFinite(secondHalfMinute) || secondHalfMinute < 45) {
            currentMinute = 45;
            break;
          }
          currentMinute = secondHalfMinute;
          if (currentMinute >= 90) {
            currentMinute = `90+${currentMinute - 90}`;
          }
          break;

        case STATUS.EXTRA_TIME:
          showMatchTime = true;
          currentMinute = `ET+${Math.floor((currentTime - startTimeUnix) / 60)}`;
          break;

        case STATUS.HALF_TIME_BREAK:
          matchStatus = "HẾT H1";
          break;

        case STATUS.NOT_STARTED:
          showMatchTime = false;
          matchStatus = "Sắp tới";
          break;

        case STATUS.FINISHED:
          matchStatus = "Kết Thúc";
          showMatchTime = false;
          break;

        case STATUS.TERMINATED:
          matchStatus = "Huỷ";
          break;

        case STATUS.POSTPONED:
          matchStatus = "Hoãn";
          break;

        case STATUS.INTERRUPTED:
          matchStatus = "Gián Đoạn";
          break;

        default:
          showMatchTime = false;
          break;
      }
    }
  }

  const getPhaseLabel = (currentStatus) => {
    switch (currentStatus) {
      case STATUS.FIRST_HALF:
        return "Hiệp 1";
      case STATUS.SECOND_HALF:
        return "Hiệp 2";
      case STATUS.EXTRA_TIME:
        return "Hiệp phụ";
      default:
        return matchStatus;
    }
  };

  if (isLive) {
    const phaseLabel = getPhaseLabel(currentStatus);
    return (
      <div className={`flex flex-col items-start ${isMobile ? "gap-1" : "gap-3"} m-0 p-0 box-border ${className}`}>
        <span className="flex items-center space-x-1.5 text-xs font-semibold uppercase text-[var(--theme-primary)] tracking-wider m-0 p-0">
          <span className="w-1.5 h-1.5 rounded-full bg-[var(--theme-primary)] animate-pulse"></span>
          {!isMobile && <span>Live</span>}
        </span>
        <span className="whitespace-nowrap font-normal text-xs text-[var(--theme-highlight)] uppercase tracking-tight m-0 p-0">
          <span className="mr-[4px]">{phaseLabel}</span>
          {showMatchTime && currentMinute !== null ? currentMinute : ""}
          {showMatchTime && <span className="animate-blink">'</span>}
        </span>
      </div>
    );
  }

  const { date, time } = formatDateTime(matchTime);
  return (
    <div className={`flex flex-col items-start ${isMobile ? "gap-2" : "gap-3"} m-0 p-0 box-border ${className}`}>
      <div className="flex items-center space-x-2 m-0 p-0">
        <img src={ICON_CALENDAR} alt="" className={isMobile ? "w-4 h-4" : "w-3.5 h-3.5"} />
        <span className={`m-0 p-0 text-[var(--theme-text)] ${isMobile ? "font-medium text-sm" : "text-sm"}`}>{date}</span>
      </div>
      <div className="flex items-center space-x-2 m-0 p-0">
        <img src={ICON_CLOCK} alt="" className={isMobile ? "w-4 h-4" : "w-3.5 h-3.5"} />
        <span className={`m-0 p-0 font-bold text-[var(--theme-highlight)] ${isMobile ? "text-sm" : "text-sm"}`}>{time}</span>
      </div>
    </div>
  );
}
